import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { CaptchaDataModel } from '../models/capture-data-model.model';
import { environment } from '@environment';

@Injectable({
    providedIn: 'root',
})
export class RecaptureService {
    constructor(private httpClient: HttpClient) {}

    checkReCaptcha(data: CaptchaDataModel): Observable<any> {
        return this.httpClient.post<any>(environment.apiMasterUrl + 'captcha/', data);
    }
}
